import { FC, useEffect, useState, Dispatch } from "react";
import { UserPasswordRecoverInterface } from "../../../middleware/interfaces/user/user-password-recover-interface";
import {
  HandleInputChange,
  StopEventPropagation,
} from "../../../helper/ui/methods";

interface userPasswordRecoverDialogProps {
  reveal: boolean;
  setRecoverPasswordDialogReveal: Dispatch<any>;
  dispatch: Dispatch<any>;
}

const UserPasswordRecoverDialog: FC<userPasswordRecoverDialogProps> = ({
  reveal,
  setRecoverPasswordDialogReveal,
  dispatch: dispatch,
}) => {
  const [submit, setSubmit] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [userPasswordRecoverData, setUserPasswordRecoverData] =
    useState<UserPasswordRecoverInterface>({
      email: "",
      type: "UserPasswordRecoverInterface",
    });

  useEffect(() => {
    if (submit) {
      dispatch({
        type: "RECOVER_PASSWORD",
        payload: userPasswordRecoverData,
      });
    }
    setSubmit(false);
    setRecoverPasswordDialogReveal(false);
  }, [submit]);

  useEffect(() => {
    if (cancel) {
      setCancel(false);
      setRecoverPasswordDialogReveal(false);
    }
  }, [cancel]);

  return (
    <>
      {(() => {
        if (reveal) {
          return (
            <div className="dialogCover" onClick={StopEventPropagation}>
              <div className="dialog">
                <div className="dialogHeader">
                  <div className="dialogHeading">
                    <h2 className="dialogTitle">Recover password</h2>
                    <span className="dialogSubtitle">
                      We email you a link to set a new one
                    </span>
                  </div>
                  <span
                    className="dialogClose"
                    onClick={() => {
                      setCancel(true);
                    }}
                  >
                    ×
                  </span>
                </div>
                <div className="dialogBody">
                  <div className="dialogValueWrapper">
                    <span className="dialogInputLabel">Email</span>
                    <input
                      type="text"
                      name="email"
                      placeholder="Email address"
                      onChange={(e) => {
                        HandleInputChange(e, setUserPasswordRecoverData);
                      }}
                    />
                  </div>
                </div>
                <div className="dialogButtonWrapper">
                  <input
                    type="button"
                    name="cancel"
                    value="Cancel"
                    onClick={() => {
                      setCancel(true);
                    }}
                  />
                  <input
                    type="button"
                    className="dialogPrimaryButton"
                    name="submit"
                    value="Submit"
                    onClick={() => {
                      setSubmit(true);
                    }}
                  />
                </div>
              </div>
            </div>
          );
        } else {
          return <></>;
        }
      })()}
    </>
  );
};

export default UserPasswordRecoverDialog;
